(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq__accordions details').forEach(function(faqAccordion) {
  faqAccordion.querySelector('summary').addEventListener('click', function(event) {
    if (event.target.parentNode.hasAttribute('open')) return;
    if (window.innerWidth < 768) {
      setTimeout(function() {
        window.scrollTo(0, event.target.getBoundingClientRect().top + window.scrollY - 90);
      }, 50);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
